"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Badge_1 = __importDefault(require("@mui/material/Badge"));
const react_1 = __importDefault(require("react"));
const Badge = ({ children, content, color = 'error', ...rest }) => (react_1.default.createElement(Badge_1.default, { badgeContent: content, color: color, componentsProps: {
        badge: {
            //@ts-ignore
            sx: {
                px: '4px',
                height: '14px',
                minWidth: '14px',
                fontSize: '9px',
                ...rest.sx,
            },
        },
    } }, children));
exports.default = Badge;
